export enum MarkersType {
  CIRCLE = 'circle',
  COMPACT = 'compact',
  ARROW = 'arrow',
  'NON-TRACKER' = 'non-tracker',
  USER = 'user',
}

export enum InsideMarkerLabel {
  SPEED = 'speed',
  ICON = 'icon',
}
